export default "__VITE_ASSET__CaJYBtot__"